<template>
    <sidebar-layout
        :moduleCode="moduleCode"
        :staticTopMenuDashboard="true"
        :mainSidebarOnlyMobile="true"
        :containerClasses="`${moduleCode}-main`"
        :activeSearchPortal="true"
    >
        <template v-if="!hasNavTopMenu" v-slot:aside-main-menu>
        	<gestao-menu :moduleCode="moduleCode"></gestao-menu>
        </template>
        <template v-if="showBreadCrumb" v-slot:breadcrumb>
            <portal-breadcrumb />
        </template>

        <template v-slot:main>
            <slot></slot>
        </template>

        <template v-slot:footer>
            <portal-footer />
        </template>
    </sidebar-layout>
</template>

<script>
    import ModuleMixin from '../shared/mixins/ModuleMixin';
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        mixins: [ ModuleMixin, GlobalMixin ],
        props: {
            showBreadCrumb: {
                default: true,
            }
        },
        components: {
            PortalFooter: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-footer" */ '@/app/shared/components/footer/Footer'),
            PortalBreadcrumb: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "portal-breadcrumb" */ '@/app/shared/components/breadcrumbs/BreadCrumbs'),
		    GestaoMenu: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "manage-menu" */ '@/app/shared/components/menu/GestaoMenu'),
        },
        computed: {
            hasNavTopMenu: function() {
                return this.layoutConf.navigation.navTopMenu;
            },
        },
    }
</script>
